import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { IProgramsDetails } from "../../exports/interfaces";
import { useMobile } from "../../hooks/custom/useMobile";
import useTab from "../../hooks/custom/useTab";
import { useLoader } from "../../context/LoaderContext";

interface Props {
  programsDetails: IProgramsDetails[];
  program: string;
  course: string;
  openSidebar: boolean;
  setOpenSidebar: React.Dispatch<React.SetStateAction<boolean>>;
}

const CourseSidebar = ({
  programsDetails,
  program,
  course,
  openSidebar,
  setOpenSidebar,
}: Props) => {
  const { setLoading } = useLoader();
  const mobile = useMobile();
  const tab = useTab();
  const [openMenu, setOpenMenu] = useState<string | null>(null);
  const [openSubMenu, setOpenSubMenu] = useState<string | null>(null);

  useEffect(() => {
    const matchedProgram = programsDetails.find(
      (item) =>
        item.title.toLowerCase() === decodeURIComponent(program).toLowerCase(),
    );

    if (matchedProgram) {
      setOpenMenu(matchedProgram.title);
    }

    const matchedCourse = matchedProgram?.courses.find(
      (item) =>
        item.name.toLowerCase() === decodeURIComponent(course).toLowerCase(),
    );

    if (matchedCourse) {
      setOpenSubMenu(matchedCourse.name);
    }

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [programsDetails, program, course, setLoading]);
  return (
    <div
      className={`col-lg-3 sidebar_mobile_wrapper ${
        openSidebar ? "sidebar_mobile_open" : ""
      }`}
    >
      <div className="sidebar_menu">
        {(mobile || tab) && (
          <div className="sidebar_mobile_header">
            <button
              className="sidebar_close_btn"
              onClick={() => setOpenSidebar(false)}
            >
              <i className="fa-solid fa-xmark"></i>
            </button>
          </div>
        )}
        <h2
          className={`${mobile || tab ? "td_fs_36" : "td_fs_48"}`}
          style={
            mobile || tab
              ? {
                  width: "90%",
                }
              : {}
          }
        >
          Academic Programs
        </h2>

        <div className="sidebar_line" />

        {programsDetails.map((item, index) => {
          const isOpen = openMenu === item.title;

          return (
            <div key={index} className="sidebar_item">
              <div
                className={`sidebar_heading ${isOpen ? "sidebar_active" : ""}`}
                onClick={() => setOpenMenu(isOpen ? null : item.title)}
              >
                <div className="sidebar_heading_left">
                  <h6
                    style={
                      mobile || tab
                        ? {
                            width: "90%",
                          }
                        : {}
                    }
                  >
                    {item.title}
                  </h6>
                  <i
                    className={`fa-solid fa-chevron-down sidebar_icon ${
                      isOpen
                        ? `rotate_icon ${!mobile && "ps-2"}`
                        : `${!mobile && "pe-2"}`
                    }`}
                  />
                </div>
              </div>

              <div className={`sidebar_submenu ${isOpen ? "open" : ""}`}>
                {item.courses.map((sub, i) => {
                  const subOpen = openSubMenu === sub.name;

                  return (
                    <Link
                      key={i}
                      to={`/sast/${item.title}/${sub.name}`}
                      className={`sidebar_subitem ${subOpen ? "sidebar_active" : ""}`}
                      onClick={() => {
                        setOpenSubMenu(sub.name);
                        if (mobile || tab) setOpenSidebar(false);
                      }}
                    >
                      <span>{sub.name}</span>
                    </Link>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CourseSidebar;
